import styled from 'styled-components';

import { EventBusy, Today } from '@mui/icons-material';
import { wellzTheme as wellzThemeMui } from '@wellz-theme/mui';
import { wellzTheme } from 'theme';

export const ContainerDates = styled.div`
  border: solid;
  border-width: 1px;
  border-radius: 16px;
  border-color: ${wellzTheme.colors.moduleBorder};
  margin-bottom: ${wellzThemeMui.spacing(6)};
  padding: ${wellzThemeMui.spacing(3)} ${wellzThemeMui.spacing(4)};
`;

export const Divider = styled.div`
  height: 56px;
  width: 1px;
  background-color: ${wellzTheme.colors.avatar};
`;

export const ContainerDivider = styled.div`
  display: flex;
  width: 24px;
  justify-content: center;
`;

export const ContainerIcon = styled.div<{ background: string }>`
  padding: ${wellzThemeMui.spacing(0.5)};
  width: 24px;
  height: 24px;
  border-radius: 99px;
  background: ${({ background }) => background};
  margin-right: ${wellzThemeMui.spacing(2)};
  justify-content: center;
  align-items: center;
`;

export const ContainerRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`;

export const EventBusyIcon = styled(EventBusy)`
  fill: white;
  width: ${wellzThemeMui.spacing(2)};
  height: ${wellzThemeMui.spacing(2)};
`;

export const CalendarIcon = styled(Today)`
  fill: white;
  width: ${wellzThemeMui.spacing(2)};
  height: ${wellzThemeMui.spacing(2)};
`;

export const CheckboxContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${wellzThemeMui.spacing(6)};
`;
